<template>
    <!-- <GChart
        type="BarChart"
        :settings="{packages: ['corechart'], language: 'pt-br'}"
        :data="chartDataFinal"
        :options="chartOptions"
    /> -->
    <div class="d-flex justify-content-center" style="position: relative; height: 60vh; width: 100%;">

        <BarChart
            :options="{
                responsive: true,
                plugins: {
                    tooltip: {
                        callbacks: {
                            beforeLabel: function(tooltipItem) {
                                let data = chartDataFinal
                                return data[tooltipItem.dataIndex].competence // Customizar label do tooltip
                            }
                        }
                    }
                }
            }"
            :data="{
                labels: chartDataFinal.map((row, index) => index + 1),
                datasets:[
                    {   
                        fill: 'origin',
                        label: 'Competencias',
                        backgroundColor: '#3866af',
                        borderColor: '#3866af',
                        data: chartDataFinal.map(row => row.note),
                        tension: 0.1
                    }
                ]
            }"
        />
    </div>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement)
export default {
    components: {
        BarChart,
    },
    props: ['chartData'],
    data() {
        return {
            chartOptions: {
                fontName: 'Inter',
                height: 400,
                legend: {
                    position: 'top',
                    maxLines: 3
                },
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.reportTransformData( this.chartData, ['competence', 'note'])
        }
    },
    methods: {
        reportTransformData (data = [], customKeys = null) {
            if(data.length > 0){
                const keys = customKeys ? customKeys : data[0]
                let newData = []
                if(data.length > 1){
    
                data.forEach((dataElement) => {
                    let temp = {};
                    keys.forEach((key, index) => {
                    temp[key] = dataElement[index]
                    })
    
                    newData.push(temp);
                });
    
                return newData.slice(1);
                }
    
                return []
            }
    
            return []
        }
    }
}
</script>

<style scoped>

</style>
